export const SET_CARD_PROGRAMS = 'SET_CARD_PROGRAMS';
export const SET_CARD_PROGRAM = 'CARD_PROGRAMS_SET_CARD_PROGRAM';
export const SET_CARDS = 'SET_CARDS';
export const REMOVE_CARD_PROGRAM = 'CARD_PROGRAMS_REMOVE_CARD_PROGRAM';
export const SET_CARD_PROGRAM_CARD_COUNTS = 'CARD_PROGRAMS_SET_CARD_PROGRAM_CARD_COUNTS';
export const ADD_CAPABILITIES = 'CARD_PROGRAMS_ADD_CAPABILITIES';
export const CARDS_SET_LOADING = 'CARDS_SET_LOADING';
export const SET_CARDS_SEARCH_PARAMS = 'SET_CARDS_SEARCH_PARAMS';
export const CARD_PROGRAMS_SET_LOADING = 'CARD_PROGRAMS_SET_LOADING';
export const ADD_CARD_PROGRAM = 'ADD_CARD_PROGRAM';
